
import { Component, Vue, Prop } from 'vue-property-decorator';
import JoeyMessage from './JoeyMessage.vue';
import JoeyLogo from '../branding/JoeyLogo.vue';
import { MessageGroupModel, AuthorType, MessageModel } from './MessageModel';

@Component({
    components: {
        JoeyMessage,
        JoeyLogo
    }
})
export default class JoeyMessageGroup extends Vue {
    @Prop() messageGroup: MessageGroupModel;

    public get messageGroupModifier() {
        switch (this.messageGroup.getAuthorType()) {
            case AuthorType.Joey:
                return 'chatbot-message-group--joey';
            case AuthorType.User:
                return 'chatbot-message-group--user';
            default:
                return '';
        }
    }

    public getMessageClass(message: MessageModel) {
        const messages = this.messageGroup.getMessages();
        if (messages.length > 1) {
            if (messages[0] === message) {
                return 'chatbot-message-group__messages__message--first';
            }
            if (messages[messages.length - 1] === message) {
                return 'chatbot-message-group__messages__message--last';
            }
            return 'chatbot-message-group__messages__message--middle';
        }
    }
}
